import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceGetLeaseMessage,
  LocationVarKey.VoiceSendGetLeaseText,
  LocationVarKey.VoiceGetLeaseTextMessage,
  LocationVarKey.VoiceForwardGetLease,
  LocationVarKey.VoiceGetLeaseEscalateTo,
  LocationVarKey.VoiceGetLeasePhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Get Lease</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceGetLeaseMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendGetLeaseText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendGetLeaseText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceGetLeaseTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardGetLease} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardGetLease, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceGetLeaseEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardGetLease, "1"), IS_EQUAL(LocationVarKey.VoiceGetLeaseEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceGetLeasePhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
